import React from 'react';

const BeforeAfterExample = () => {
  return (
    <div className="max-w-6xl mx-auto p-8">
      <h3 className="text-2xl font-bold text-center mb-8">
        See the Difference: From Video to Insight
      </h3>

      <div className="grid md:grid-cols-2 gap-8 items-center">
        {/* BEFORE - Video Thumbnail */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="bg-gray-800 text-white text-center py-2 rounded-t-lg font-semibold mb-4">
            BEFORE: Raw Video
          </div>

          {/* Mock YouTube Thumbnail */}
          <div className="relative bg-black aspect-video rounded-lg mb-4 overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="text-6xl mb-2">▶️</div>
                <div className="text-white text-sm bg-black bg-opacity-75 px-4 py-2 rounded">
                  "Advanced Penetration Testing Tutorial"
                </div>
              </div>
            </div>
            {/* YouTube-style overlay */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-3">
              <div className="text-white text-xs">👤 HackerChannel123 • 45K views • 2 days ago</div>
            </div>
          </div>

          {/* Video Info */}
          <div className="space-y-2 text-sm text-gray-700">
            <p><strong>Title:</strong> "Advanced Penetration Testing Tutorial"</p>
            <p><strong>Description:</strong> "Learn advanced techniques for network penetration..."</p>
            <p><strong>Tags:</strong> #hacking #tutorial #cybersecurity #pentest</p>
          </div>

          <div className="mt-4 p-3 bg-gray-100 rounded text-center">
            <p className="text-sm text-gray-600 italic">
              ❓ Is this educational or malicious?<br />
              🤔 Safe for classroom use?<br />
              ⏱️ Manual review: 30+ minutes
            </p>
          </div>
        </div>

        {/* Arrow */}
        <div className="hidden md:block text-center text-6xl text-blue-600">
          →
        </div>
        <div className="md:hidden text-center text-6xl text-blue-600">
          ↓
        </div>

        {/* AFTER - Analysis Report */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <div className="bg-blue-600 text-white text-center py-2 rounded-t-lg font-semibold mb-4">
            AFTER: AI Analysis Report
          </div>

          {/* Risk Score Card */}
          <div className="bg-gradient-to-r from-orange-50 to-red-50 border-3 border-orange-500 rounded-lg p-6 mb-4">
            <div className="text-center">
              <div className="text-5xl font-bold text-orange-600 mb-2">
                72/100
              </div>
              <div className="text-xl font-semibold text-orange-700">
                HIGH RISK
              </div>
            </div>
          </div>

          {/* Analysis Details */}
          <div className="space-y-3">
            <div className="bg-gray-50 rounded-lg p-3">
              <div className="font-semibold text-sm mb-1 flex items-center">
                <span className="mr-2">👁️</span> Visual Analysis
              </div>
              <ul className="text-xs text-gray-700 space-y-1">
                <li>✓ Kali Linux interface detected (Frame 3)</li>
                <li>✓ Metasploit framework identified (Frame 5)</li>
                <li>✓ Network exploitation demo (Frame 7)</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-lg p-3">
              <div className="font-semibold text-sm mb-1 flex items-center">
                <span className="mr-2">🎤</span> Audio Analysis
              </div>
              <ul className="text-xs text-gray-700 space-y-1">
                <li>✓ Keywords: "exploit", "vulnerability", "bypass"</li>
                <li>✓ Instructional tone for attack techniques</li>
                <li>✓ No educational disclaimers detected</li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-lg p-3">
              <div className="font-semibold text-sm mb-1 flex items-center">
                <span className="mr-2">📊</span> Metadata Analysis
              </div>
              <ul className="text-xs text-gray-700 space-y-1">
                <li>✓ Tags match known threat patterns</li>
                <li>✓ Channel history: 15 similar videos</li>
                <li>✓ No institutional affiliation</li>
              </ul>
            </div>
          </div>

          {/* Recommendation */}
          <div className="mt-4 p-3 bg-orange-100 border border-orange-300 rounded">
            <p className="text-sm font-semibold text-orange-800">
              ⚠️ Recommendation: NOT SUITABLE for classroom use
            </p>
            <p className="text-xs text-orange-700 mt-1">
              Content demonstrates active exploitation techniques without proper educational context. Recommend human expert review before any institutional use.
            </p>
          </div>

          <div className="mt-4 text-center">
            <p className="text-xs text-gray-500">
              ⏱️ Analysis completed in 45 seconds
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Summary */}
      <div className="mt-8 grid md:grid-cols-3 gap-4">
        <div className="bg-blue-50 p-4 rounded-lg text-center">
          <div className="text-3xl mb-2">⚡</div>
          <div className="font-semibold">60x Faster</div>
          <div className="text-sm text-gray-600">30+ min → 45 sec</div>
        </div>

        <div className="bg-green-50 p-4 rounded-lg text-center">
          <div className="text-3xl mb-2">🎯</div>
          <div className="font-semibold">Comprehensive</div>
          <div className="text-sm text-gray-600">Visual + Audio + Metadata</div>
        </div>

        <div className="bg-purple-50 p-4 rounded-lg text-center">
          <div className="text-3xl mb-2">🤖</div>
          <div className="font-semibold">AI-Powered</div>
          <div className="text-sm text-gray-600">GPT-4 Vision + Whisper</div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterExample;
